import { Injectable, Type } from "@angular/core";
import { NatCatalogRepository } from "@natiwi/core/network/repositories/catalog.repository";
import { NatRestAdapter } from "@natiwi/core/network/adapters/rest.adapter";
import { OrmPaymentOption } from "@natiwi/shared/models/payment-option.model";

export class NatPaymentOptionRepository extends NatCatalogRepository<OrmPaymentOption> {

    constructor(adapter?: NatRestAdapter) {
        super(adapter);
        let repoUrl: string = '/paymentOptions';
        let repoModel: Type<OrmPaymentOption> = OrmPaymentOption;
        this.init(repoUrl, repoModel);
    }
}